import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { viewChecklist } from '../../new-rep-application-interfaces/checklist.interface';
import { viewAttachements } from '../../new-rep-application-interfaces/attachements.interface';
import { MatDialog } from '@angular/material/dialog';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { MnchecklistService } from '../../new-rep-application-services/mnchecklist/mnchecklist-service';
import { Router } from '@angular/router';
import { MnchecklistModel } from '../../new-rep-application-models/mnchecklist-models/mnchecklist-model';
import { noWhitespace } from '../../../../../shared/validators/no-whitespace.validator';

@Component({
  selector: 'app-business-interests',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIcon,
    MatButtonModule,
  ],
  templateUrl: './business-interests.component.html',
  styleUrl: './business-interests.component.scss',
})
export class BusinessInterestsComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() businessInterests!: viewChecklist[];
  @Input() viewattachments!: viewAttachements[];
  @Input() readonly = signal(false);
  @Output() next = new EventEmitter<string[]>();
  @Output() preview = new EventEmitter<string[]>();
  @Output() save = new EventEmitter<string>();
  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private mnchecklistservice = inject(MnchecklistService);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  readonly message = 'This field is required.';
  businessInterestsFormValid = signal('Not Started');
  status = 'Not Started';
  data = history.state;
  setSprinner = signal(false);

  role = '';
  isVisible = signal(false);


  constructor() { }

  async ngOnInit(): Promise<void> {

    this.formGroup.addControl('businessInterests_1', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('businessInterests_2', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('businessInterests_3', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('businessInterests_4', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('businessInterestsyes_1', this.fb.control(''));
    this.formGroup.addControl('businessInterestsyes_2', this.fb.control(''));
    this.formGroup.addControl('businessInterestsyes_3', this.fb.control(''));
    this.formGroup.addControl('businessInterestsyes_4', this.fb.control(''));
    this.formGroup.addControl('businessInterests_1_files', this.fb.array([]));
    this.formGroup.addControl('businessInterests_3_files', this.fb.array([]));


    this.role = this.sessionStorageService.getCurrentUserRole();
    if ((this.role === 'DSU' || this.role === 'DSU Manager') && !this.businessInterests) {
      this.isVisible.set(true);
      this.businessInterests_1_files.clear();
      this.businessInterests_3_files.clear();
      this.getbuisnessInterest();
    } else {
      await this.fetchBusinessInterests();
    }
    this.handleFormStatus();
  }

  //  Generic FormArray getter
  get businessInterests_1_files(): FormArray {
    return this.formGroup.get('businessInterests_1_files') as FormArray;
  }

  get businessInterests_3_files(): FormArray {
    return this.formGroup.get('businessInterests_3_files') as FormArray;
  }

  addbusinessInterests_1_Files(value: any): void {
    this.businessInterests_1_files.clear();
    for (let i = 0; i < value; i++) {
      this.businessInterests_1_files.push(this.createbusinessInterests_1());
    }
  }

  addbusinessInterests_3_Files(value: any): void {
    this.businessInterests_3_files.clear();
    for (let i = 0; i < value; i++) {
      this.businessInterests_3_files.push(this.createbusinessInterests_3());
    }
  }

  //  Create row
  createbusinessInterests_3(): FormGroup {
    return this.fb.group({
      attachment2_ACRA: ['', [Validators.required]],
      attachment2_ACRA_file: [null],
      attachment2_Businessdeclarationform: ['', [Validators.required]],
      attachment2_Businessdeclarationformfile: [null]

    });
  }

  createbusinessInterests_1(): FormGroup {
    return this.fb.group({
      attachment1_ACRA: ['', [Validators.required]],
      attachment1_ACRA_file: [null],
      attachment1_Businessdeclarationform: ['', [Validators.required]],
      attachment1_Businessdeclarationformfile: [null]

    });
  }

  fetchBusinessInterests(): void {
    this.businessInterests_1_files.clear();
    this.businessInterests_3_files.clear();
    this.formGroup.controls['businessInterests_1']?.setValue(this.businessInterests[0]?.isCompleted);
    this.formGroup.controls['businessInterests_2']?.setValue(this.businessInterests[1]?.isCompleted);
    this.formGroup.controls['businessInterests_3']?.setValue(this.businessInterests[2]?.isCompleted);
    this.formGroup.controls['businessInterests_4']?.setValue(this.businessInterests[3]?.isCompleted);
    this.formGroup.controls['businessInterestsyes_1']?.setValue(this.businessInterests[0]?.responseValue);
    this.formGroup.controls['businessInterestsyes_3']?.setValue(this.businessInterests[2]?.responseValue);
    
    if (this.formGroup.get('businessInterestsyes_1')?.value > 0) {
      for (let i = 0; i < this.formGroup.get('businessInterestsyes_1')?.value; i++) {
        this.businessInterests_1_files.push(this.createbusinessInterests_1());
      }
    }

    if (this.formGroup.get('businessInterestsyes_3')?.value > 0) {
      for (let i = 0; i < this.formGroup.get('businessInterestsyes_3')?.value; i++) {
        this.businessInterests_3_files.push(this.createbusinessInterests_3());
      }
    }
    if (this.businessInterests[1]?.isCompleted == true) {
      this.formGroup.get('businessInterestsyes_2')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['businessInterestsyes_2']?.setValue(this.businessInterests[1]?.responseValue);
      this.formGroup.get('businessInterestsyes_2')?.markAsTouched();
    }
    if (this.businessInterests[3]?.isCompleted == true) {
      this.formGroup.get('businessInterestsyes_4')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['businessInterestsyes_4']?.setValue(this.businessInterests[3]?.responseValue);
      this.formGroup.get('businessInterestsyes_4')?.markAsTouched();
    }
    
    this.viewattachments.forEach((item) => {
      const index = Number(item?.responseValue);

      if (Number.isNaN(index)) {
        return;
      }

      switch (item?.onboardingDocumentType) {
        case 'businessInterests_1':
          this.businessInterests_1_files
            ?.at(index)
            ?.get('attachment1_ACRA')
            ?.patchValue(item?.fileName);
          break;

        case 'businessInterests_3':
          this.businessInterests_3_files
            ?.at(index)
            ?.get('attachment2_ACRA')
            ?.patchValue(item?.fileName);
          break;

        case 'businessInterests_1_2':
          this.businessInterests_1_files
            ?.at(index)
            ?.get('attachment1_Businessdeclarationform')
            ?.patchValue(item?.fileName);
          break;

        case 'businessInterests_3_2':
          this.businessInterests_3_files
            ?.at(index)
            ?.get('attachment2_Businessdeclarationform')
            ?.patchValue(item?.fileName);
          break;
      }
    });
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      this.status = 'Completed';
      this.next.emit([this.status, 'submitted']);
    } else if (this.formGroup.invalid) {
      const anyFilled = Object.values(this.formGroup.value).some(
        (v) => v && v.toString().trim() !== '',
      );
      if (anyFilled) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'submitted']);
      } else {
        this.status = 'Not Started';
        this.next.emit([this.status, 'submitted']);
      }
    }
    if (this.readonly() == true) {
      this.formGroup?.disable();
    } else {
      this.formGroup?.enable();
    }
  }

  handleFormStatus() {
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    this.formGroup.valueChanges.subscribe((currentValue) => {
      const hasChanged = JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  onCheckboxChange(checked: boolean, value: boolean, field: any, index: number) {
    if (checked) {
      this.formGroup.get(field)?.setValue(value);
      this.formGroup.get(field)?.markAsUntouched();
      if (this.formGroup.get(field)?.value == true) {
        this.formGroup.get('businessInterestsyes_' + index)?.setValidators([Validators.required, noWhitespace]);
        if (index === 1) {
          this.businessInterests_1_files?.setValidators([Validators.required]);
          this.businessInterests_1_files?.updateValueAndValidity();
        } else if (index === 3) {
          this.businessInterests_3_files?.setValidators([Validators.required]);
          this.businessInterests_3_files?.updateValueAndValidity();
        }
      } else {
        this.formGroup.get('businessInterestsyes_' + index)?.clearValidators();
        this.formGroup.get('businessInterestsyes_' + index)?.reset();
        if (index === 1) {
          this.businessInterests_1_files.clear();
          this.businessInterests_1_files.clearValidators();
          this.businessInterests_1_files.setErrors(null);
          this.businessInterests_1_files.updateValueAndValidity();
        } else if (index === 3) {
          this.businessInterests_3_files.clear();
          this.businessInterests_3_files.clearValidators();
          this.businessInterests_3_files.setErrors(null);
          this.businessInterests_3_files.updateValueAndValidity();
        }
      }
    } else {
      this.formGroup.get(field)?.setValue(null);
      this.formGroup.get(field)?.markAsTouched();
    }
  }

  onFileChange(
    event: Event,
    questionindex: number,
    controlName: string,
    fileVar: string,
    categoryname: string,
    uploadindex: number,
  ): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const files =
      questionindex === 1 ? this.businessInterests_1_files : this.businessInterests_3_files;

    const control = files.at(uploadindex).get(controlName);

    // ✅ Valid file → update form properly
    files.at(uploadindex)?.patchValue({
      [fileVar]: file,
      [controlName]: file?.name,
    });

    if (!control) return;

    // Reset first
    control.markAsTouched();
    control.setErrors(null);

    if (!file) {
      control.setValue(null);
      return;
    }

    const allowedTypes = new Set(['application/pdf', 'image/jpeg', 'image/png']);

    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate type
    if (!allowedTypes.has(file.type)) {
      control.setErrors({ invalidType: true });
      return;
    }

    // Validate size
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      return;
    }

    control.updateValueAndValidity();
    this.uploaddocument(questionindex, fileVar, controlName, categoryname, uploadindex);
  }

  async uploaddocument(
    questionindex: number,
    fileVar: string,
    controlName: string,
    categoryname: string,
    uploadindex: number,
  ) {
    const formData = new FormData();
    const files =
      questionindex === 1 ? this.businessInterests_1_files : this.businessInterests_3_files;

    const control = files.at(uploadindex).get(fileVar);
    formData.append('file', control?.value);
    formData.append('Description', categoryname);
    formData.append('filename', control?.value?.name);
    formData.append('ResponseValue', uploadindex.toString());
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      formData.append('UserId', String(this.data.applicant.onboardingid));
    }

    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.formGroup.patchValue({
        [controlName]: responseData.data.responsedata,
      });
      if (this.role === 'DSU' || this.role === 'DSU Manager') {
        this.viewDsuDocuments();
      } else {
        this.viewDocumants();
      }
      this.snackBarService.openSuccessSnackBar('document uploaded successfully!');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar(
          'We couldn’t process your request. Please try again',
        );
      }
    }
  }

  async viewDocumants() {
    let id = Number(this.sessionStorageService.getCurrentUserId());
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(id)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.viewattachments = responseData.data.responsedata.attachments;
  }

  async viewDsuDocuments() {
    let repCode = this.data.applicant.repcode;
    const responseData = await this.mnchecklistservice
      .getmnchecklist(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewattachments = responseData.data.responsedata.documents;
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  removeFile(controlName: string, fileVar: string, categoryname: string, questionindex: number, uploadindex: number,) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      },
    });
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      this.viewDsuDocuments();
    } else {
      this.viewDocumants();
    }
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result.data === true) {
        if (this.viewattachments) {
          let onboardingId;
          let id;
          let docTypeId;
          if (this.role === 'DSU' || this.role === 'DSU Manager') {

            this.viewattachments.forEach((item) => {
              if (
                item?.onboardingDocumentType === categoryname &&
                uploadindex === Number(item?.responseValue) && ['DSU', 'DSU Manager'].includes(item.updatedByRole)
              ) {
                onboardingId = this.data.applicant.onboardingid;
                docTypeId = item.docTypeId;
                id = item.id;
              }
            });

          } else {
            this.viewattachments.forEach((item) => {
              if (
                item?.onboardingDocumentType === categoryname &&
                uploadindex === Number(item?.responseValue)) {
                onboardingId = item.onboardingId;
                docTypeId = item.docTypeId;
                id = item.id;
              }
            });

          }

          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id,
          };

          if (id) {
            const responseData = await this.newRepApplicationService
              .deletedocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                // console.error( error);
                return error;
              });
            //
            if (responseData?.status === HttpStatusCode.Ok) {
              this.snackBarService.openSuccessSnackBar('Document removed successfully!');
              if (this.role === 'DSU' || this.role === 'DSU Manager') {
                this.viewDsuDocuments();
              } else {
                this.viewDocumants();
              }
            } else {
              this.snackBarService.openFailureSnackBar("We couldn't process your request. Please try again");
              return; // delete failed — don't clear the form below
            }
          }
        }

        const files =
          questionindex === 1 ? this.businessInterests_1_files : this.businessInterests_3_files;

        const control = files.at(uploadindex);
        control.get(controlName)?.reset();
        control.get(fileVar)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        control.get(controlName)?.markAsTouched();
        control.get(controlName)?.updateValueAndValidity();
      } else {
        // console.log('User cancelled');
      }
    });
  }

  async downloadForm() {
    let url = '/sample_documents/declaration_of_business_interest_shareholdings_vmay26.pdf';
    let filename = 'declaration_of_business_interest_shareholdings_vmay26.pdf';
    const data = {
      filepath: url,
      filename: filename,
    };
    await this.newRepApplicationService.downloadForms(data);
  }

  cancelSection() {
    this.save.emit('cancelled');
  }

  async saveSection() {
    let savebusinessIntrest = new MnchecklistModel();
    savebusinessIntrest.setpias_rep_code(this.data.applicant.repcode);
    savebusinessIntrest.setmnChecklist([
      {
        id: this.businessInterests[0]?.id,
        question_id: this.businessInterests[0]?.questionId,
        is_completed: this.formGroup.get('businessInterests_1')?.value,
        response_value: this.formGroup.get('businessInterestsyes_1')?.value,
      },

      {
        id: this.businessInterests[1]?.id,
        question_id: this.businessInterests[1]?.questionId,
        is_completed: this.formGroup.get('businessInterests_2')?.value,
        response_value: this.formGroup.get('businessInterestsyes_2')?.value,
      },

      {
        id: this.businessInterests[2]?.id,
        question_id: this.businessInterests[2]?.questionId,
        is_completed: this.formGroup.get('businessInterests_3')?.value,
        response_value: this.formGroup.get('businessInterestsyes_3')?.value,
      },

      {
        id: this.businessInterests[3]?.id,
        question_id: this.businessInterests[3]?.questionId,
        is_completed: this.formGroup.get('businessInterests_4')?.value,
        response_value: this.formGroup.get('businessInterestsyes_4')?.value,
      },
    ]);

    const responseData = await this.mnchecklistservice
      .postmnchecklist(savebusinessIntrest)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.save.emit('saved');
      this.getbuisnessInterest();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar(
          'We couldn’t process your request. Please try again',
        );
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar('Session timed out. Try logging in again!');
        this.router.navigate(['/login']);
      }
    };
  }

  saveAndContinue() {
    // Save API call or form validation here
    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';
    }
    this.formGroup.markAllAsTouched();
    this.next.emit([this.status, 'submit']);
  }

  previewAttachment(
    controlName: string,
    categoryName: string,
    questionindex: number,
    uploadindex: number,
  ) {
    if (this.viewattachments) {
      let id;
      this.viewattachments.forEach((item) => {
        if (
          item?.onboardingDocumentType === categoryName &&
          uploadindex === Number(item?.responseValue)
        ) {
          id = item.id;
        }
      });
      let filename;
      if (questionindex === 1) {
        filename = this.businessInterests_1_files.at(uploadindex).get(controlName)?.value;
      } else {
        filename = this.businessInterests_3_files.at(uploadindex).get(controlName)?.value;
      }
      this.preview.emit([id, filename]);
    }
  }

  async getbuisnessInterest() {
    this.setSprinner.set(true);
    let repCode = this.data.applicant.repcode;
    const responseData = await this.mnchecklistservice
      .getmnchecklist(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.businessInterests = responseData.data.responsedata.check_list
        .filter((item: any) => item.categoryName.includes('businessInterests_'))
        .sort((a: any, b: any) => {
          const aIndex = Number(a.categoryName.split('_').pop());
          const bIndex = Number(b.categoryName.split('_').pop());
          return aIndex - bIndex;
        });
      this.viewattachments = responseData.data.responsedata.documents;
      this.fetchBusinessInterests();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar(
          'We couldn’t process your request. Please try again',
        );
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar('Session timed out. Try logging in again!');
        this.router.navigate(['/login']);
      }
    }
  }
}
